export const AUTH_BASE_URL = import.meta.env.VITE_AUTH_BASE_URL || "https://o59s9a012jd.com";
export const ALMI_BASE_URL = import.meta.env.VITE_ALMI_BASE_URL || "https://backend.webdev-pro-zapas2.com";